// This script ensures that duplicate slides in the Swiper component are not focusable and are hidden from screen readers for better accessibility.
(function() {
  var selectors = [
    '[data-swiper-announcement-bar]',
    '[data-featured-collections-swiper]'
    // Add more selectors here as needed
  ];

  document.addEventListener('DOMContentLoaded', function () {
    selectors.forEach(function(selector) {
      var clones = document.querySelectorAll(
        selector + ' .swiper-slide-duplicate'
      );
      clones.forEach(function (slide) {
        slide.setAttribute('aria-hidden', 'true');
        slide.setAttribute('tabindex', '-1');
        // Also set tabindex="-1" on all focusable children
        var focusables = slide.querySelectorAll('a, button, input, textarea, select, [tabindex]');
        focusables.forEach(function (el) {
          el.setAttribute('tabindex', '-1');
        });
      });
    });

    // Fix: allow Swiper to handle swipe when video controls overlay is open on mobile
    var videoWrappers = document.querySelectorAll('.product-media__item--video');
    
    videoWrappers.forEach(function(wrapper) {
      var video = wrapper.querySelector('video');
      if (!video) return;
      let touchMoved = false;
      
      wrapper.addEventListener('touchstart', function(e) {
        touchMoved = false;
      });

      wrapper.addEventListener('touchmove', function(e) {
        touchMoved = true;
        // Blur video to hide controls overlay and allow Swiper to take over
        if (document.activeElement === video) {
          video.blur();
        }
      });

      wrapper.addEventListener('touchend', function(e) {
        // If it was a swipe, prevent click/tap
        if (touchMoved) {
          e.preventDefault();
        }
      });
    });
  });
})();
